{#if fields.videoUrl}
  <div class="video-wrapper {fields.hero ? 'hero' : 'normal'} {videoType}">
    {#if videoType === 'youtube'}
      {#if fields?.videoPlaceholder}
        <img src={`${fields.videoPlaceholder}?size=xs`} alt="" class="placeholder"/>
      {/if}
      <iframe width="100%" height="100%"
        src={`${getVideoSrc(fields.videoUrl)}?autoplay=${fields.autoplay ? '1' : '0'}&mute=${fields.mute ? '1' : '0'}&controls=${fields.controls ? '1' : '0'}&loop=${fields.loop ? `1&playlist=${videoId}` : '0'}&modestbranding=1`}
        title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write;
          encrypted-media; gyroscope; picture-in-picture;
          web-share" allowfullscreen>
      </iframe>
    {:else if videoType === 'vimeo'}
      {#if fields?.videoPlaceholder}
        <img src={`${fields.videoPlaceholder}?size=xs`} alt="" class="placeholder"/>
      {/if}
      <iframe width="100%" height="100%"
        src={`${getVideoSrc(fields.videoUrl)}?autoplay=${fields.autoplay ? '1' : '0'}&muted=${fields.mute ? '1' : '0'}&controls=${fields.controls ? '1' : '0'}&loop=${fields.loop ? '1' : '0'}&background=1`}
        title="Vimeo video player" frameborder="0"
        allow="autoplay; fullscreen" allowfullscreen>
      </iframe>
    {:else}
      <video width="100%" height="auto" class="{fields.hero ? 'hero' : 'normal'}" autoplay={fields.autoplay} muted={fields.mute} controls={fields.controls} loop={fields.loop}>
        <source src={fields.videoUrl} type="video/mp4">
      </video>
    {/if}
  </div>
{:else}
  <div class="no-video">
    <h3>Video</h3>
    <p>Enter edit mode and select this plugin to choose a video</p>
  </div>
{/if}

<script>
  export let fields = {}
  import { getVideoSrc, findVideoType, findVideoId } from './utils.js'

  const videoType = findVideoType(fields.videoUrl)
  const videoId = findVideoId(fields.videoUrl)
</script>

<style lang="scss">.video-wrapper.youtube.normal, .video-wrapper.vimeo.normal {
  position: relative;
  padding-bottom: 56.25%;
}
.video-wrapper.youtube.normal iframe, .video-wrapper.vimeo.normal iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.video-wrapper.youtube.hero, .video-wrapper.vimeo.hero {
  height: 100vh;
  width: 100%;
  position: relative;
}
.video-wrapper.youtube.hero::after, .video-wrapper.vimeo.hero::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}
.video-wrapper.youtube.hero iframe, .video-wrapper.vimeo.hero iframe {
  width: 100vw;
  height: 56.25vw;
  min-width: 177.77vh;
  min-height: 100vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video-wrapper.jolojo.hero {
  height: 100vh;
  width: 100%;
}
.video-wrapper.jolojo.hero video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.no-video {
  width: 100%;
  outline: dashed 2px #888;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  padding: 15px;
  box-sizing: border-box;
  text-emphasis: center;
}

.placeholder {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(4px);
  position: absolute;
  top: 0px;
  left: 0px;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>